export default __webpack_public_path__ + "static/media/rollingShutters.bcfa40f3.jpeg";